export var wrapper = 'w-full flex flex-row justify-center items-center';
export var paginationItem = 'p-1 border border-textLight rounded-full mr-1 ';
export var activePaginationItem = "".concat(paginationItem, " bg-secondary border-none w-5");
//# sourceMappingURL=slider-pagination.styles.js.map